import { TextField } from '@material-ui/core';
import { Stack } from '@mui/system';
import React from 'react';

export default class CustomExpire extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            day: props.value.day, 
            desc: props.value.descrizione,
        };
    }

    componentDidUpdate() {
        if (this.props.value.desc !== this.state.desc || this.props.value.day !== this.state.day) {
            this.setState({
                day: this.props.value.day,
                desc: this.props.value.desc,
            })
        }
    }

    render() {
        return(
            <Stack direction='row' spacing={2} sx={{flex: 1}}>
                <TextField
                    style={{width: 300}}
                    value={this.state.day}
                    label="Data sopralluogo"
                    onChange={(e) => {
                        this.setState({day: e.target.value});
                        this.props.onDayUpdate && this.props.onDayUpdate(e.target.value);
                    }}
                    type="date"
                    variant="outlined" 
                    InputLabelProps={{shrink: true}}                
                />  
                <TextField
                    style={{width: 600}}
                    value={this.state.desc}
                    label="Descrizione sopralluogo"
                    onChange={(e) => {
                        this.setState({desc: e.target.value});
                        this.props.onDescUpdate && this.props.onDescUpdate(e.target.value);
                    }}
                    multiline
                    variant="outlined" 
                    InputLabelProps={{shrink: true}}
                />  
                <img src={require('../images/close.png')} alt="" title="Rimuovi" style={{ cursor: 'pointer', width: 15, height: 15, marginLeft: 10, marginRight: -5, marginTop: 12 }} onClick={() => this.props.onDelete()} />
            </Stack>
        );
    }
}